// src/components/DataTable.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  TextField,
  Typography,
  Grid,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  getCompanySuppliersAction,
  getOrderBookingPaginatedAction,
  getOrderPaginatedAction,
  getPoOrderDetailsAction,
} from './Action';

import moment from 'moment';
import {
  bookingApprovalStatusEnum,
  bookingApprovalStatusEnums,
  getOrderFinalStatusById,
  getRGBAColor,
  orderApprovalStatusMap,
  orderFinalStatusEnum,
  SupplierModuleTypeEnum,
} from '../../utils/settings';
import TopNav from '../TopNav/TopNav';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';

export default function SecondaryOrderList() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBookingsList, setOrderBookingsList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [startEndDate, setStartEndDate] = useState({
    startDate: moment(moment().subtract(30, 'days')).format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });

  const [orderList, setOrderList] = useState();
  const [companiesList, setCompaniesList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const [company, setCompany] = useState({});
  const [status, setStatus] = useState({});
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const getOrders = async () => {
    const params = new URLSearchParams();
    params.append('f', 'id$gte$0');
    params.append('o', 'id$desc');
    params.append('page', 1);
    params.append('page_size', 10);
    params.append('is_buyer', false);

    if (startEndDate.startDate || startEndDate.endDate) {
      params.append(
        'f',
        `date$gte$${moment(startEndDate.startDate).format('YYYY-MM-DD')}`,
      );
      params.append(
        'f',
        `date$lte$${moment(startEndDate.endDate).format('YYYY-MM-DD')}`,
      );
    }
    if (Object.keys(company).length > 0) {
      params.append('f', `supplier_id$eq$${company.id}`);
    }
    if (Object.keys(status).length > 0) {
      params.append('f', `final_status$eq$${status.id}`);
    }

    const { data, error, message } = await getOrderPaginatedAction(params);

    if (!error) {
      setOrderList(data);
    }
  };

  const getCompany = async () => {
    const { data, error, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.dp_history_enabled,
    );
    if (!error) {
      let list = [];
      data.map((industry) => {
        industry.suppliers_list.map((supplier) => {
          list.push({
            id: supplier.id,
            name: supplier.name,
          });
        });
      });
      setCompaniesList(list);
    } else return toast.error(message);
  };
  useEffect(() => {
    getOrders();
    getCompany();
    getStatusList();
  }, []);

  const getStatusList = () => {
    let list = [];
    orderFinalStatusEnum.map((item) => {
      list.push({
        id: item.id,
        name: item.name,
      });
    });
    setStatusList(list);
  };

  useEffect(() => {
    if (company || status || startEndDate) {
      getOrders();
    }
  }, [company, status, startEndDate]);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        {' '}
        <Typography
          variant='h5'
          style={{ marginBottom: '2rem', fontWeight: 'bold' }}
        >
          Secondary orders List
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ width: '70%' }}>
            <TextField
              label='Start Date'
              type='date'
              InputLabelProps={{ shrink: true }}
              value={startEndDate.startDate}
              sx={{ mr: 2 }}
              onChange={(e) => {
                setStartEndDate({
                  ...startEndDate,
                  startDate: e.target.value,
                });
              }}
            />
            <TextField
              label='End Date'
              type='date'
              value={startEndDate.endDate}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setStartEndDate({
                  ...startEndDate,
                  endDate: e.target.value,
                });
              }}
            />
            <FormControl sx={{ marginLeft: '2rem', width: '25%' }}>
              <InputLabel>Select Company</InputLabel>
              <Select
                value={company?.id}
                label='Select Company'
                onChange={(e) => {
                  setCompany({
                    id: e.target.value,
                    name: e.target.name,
                  });
                }}
              >
                {companiesList &&
                  companiesList.length > 0 &&
                  companiesList.map((company) => (
                    <MenuItem
                      value={company.id}
                      key={company.id}
                    >
                      {company.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: '2rem', width: '25%' }}>
              <InputLabel>Select Status</InputLabel>
              <Select
                value={status?.id}
                label='Select Status'
                onChange={(e) => {
                  setStatus({
                    id: e.target.value,
                    name: statusList.find(
                      (status) => status.id == e.target.value,
                    ).name,
                  });
                }}
              >
                {statusList &&
                  statusList.length > 0 &&
                  statusList.map((status) => (
                    <MenuItem
                      value={status.id}
                      key={status.id}
                    >
                      {status.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>User PO ID</TableCell>
                  <TableCell align='center'>Order ID</TableCell>
                  <TableCell align='center'>Date</TableCell>
                  {/* <TableCell>UOM</TableCell> */}
                  <TableCell align='center'>Status</TableCell>
                  <TableCell align='center'>Dispatch Qty</TableCell>
                  <TableCell align='center'>Delivered Qty</TableCell>
                  <TableCell align='center'>Pending Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderList
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: 'pointer',
                      }}
                      onClick={async () => {
                        const { data, error, message } =
                          await getPoOrderDetailsAction({
                            order_id: row.order_id,
                          });

                        if (!error) {
                          dispatch({
                            type: 'SET_EDIT_PO_BOOKING_DETAILS',
                            data: data,
                          });

                          dispatch({
                            type: 'IS_SECONDARY_ORDER',
                            data: true,
                          });

                          navigate('/order-booking/dispatch-status-details', {
                            state: {
                              orderID: row.order_id,
                            },
                          });
                        } else {
                          return toast.error(message);
                        }
                      }}
                    >
                      <TableCell align='center'>
                        {row.user_booking_id ? row.user_booking_id : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        <Box
                          sx={{
                            alignItems: 'left',
                          }}
                        >
                          {row.order_id}
                          <Grid sx={{ fontSize: 'small', color: 'gray' }}>
                            {' '}
                            <Typography variant='body2'>
                              Ship to party:
                            </Typography>
                            {row.ship_to_parties.map((item, index) => {
                              return (
                                <Grid>
                                  <Typography variant='body2'>
                                    {item.company_name}
                                  </Typography>
                                  {index !== row.ship_to_parties.length - 1 && (
                                    <Typography variant='body2'>,</Typography>
                                  )}
                                </Grid>
                              );
                            })}
                          </Grid>
                        </Box>
                      </TableCell>
                      <TableCell align='center'>
                        {moment(row?.date).format('DD MMM YYYY')}
                      </TableCell>

                      <TableCell
                        sx={{
                          width: '10rem',
                        }}
                        align='center'
                      >
                        <Box
                          sx={{
                            borderRadius: '10px',
                            textAlign: 'center',
                            backgroundColor: getRGBAColor(
                              getOrderFinalStatusById(row?.final_status)?.color,
                            ),
                          }}
                        >
                          <Typography
                            sx={{
                              color: getOrderFinalStatusById(row?.final_status)
                                ?.color,
                            }}
                          >
                            {getOrderFinalStatusById(row?.final_status)?.name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align='center'>{`${row.order_details[0].dispatch_plan_quantity.quantity_in_metric_ton} ${row.order_details[0].dispatch_plan_quantity.unit}`}</TableCell>
                      <TableCell align='center'>{`${row.order_details[0].delivered_quantity.quantity_in_metric_ton} ${row.order_details[0].delivered_quantity.unit}`}</TableCell>
                      <TableCell align='center'>{`${row.order_details[0].pending_quantity.quantity_in_metric_ton} ${row.order_details[0].pending_quantity.unit}`}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component='div'
            count={orderBookingsList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Container>
    </>
  );
}
